
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Dialog from '@mui/material/Dialog';
import IconButton from '@mui/material/IconButton';
import { useTheme } from '@mui/material/styles';

import { SecureImage } from './secure-image';

interface ImageLightboxProps {
  open: boolean;
  onClose: () => void;
  imageUrl: string | null;
  imagePath?: string | null;
  altText: string;
}

export function ImageLightbox({ open, onClose, imageUrl, imagePath, altText }: ImageLightboxProps) {
  const theme = useTheme();

  if (!imageUrl && !imagePath) return null;

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth={false}
      PaperProps={{
        sx: {
          bgcolor: 'transparent',
          boxShadow: 'none',
          overflow: 'visible',
          m: 1,
          maxHeight: 'calc(100% - 16px)',
          maxWidth: 'calc(100% - 16px)',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
        },
      }}
      BackdropProps={{
        sx: {
          bgcolor: 'rgba(0, 0, 0, 0.9)',
          backdropFilter: 'blur(4px)',
        },
      }}
    >
      <Box sx={{ position: 'relative', maxWidth: '100%', maxHeight: '100%' }}>
        <IconButton
          onClick={onClose}
          sx={{
            position: 'fixed',
            top: 16,
            right: 16,
            color: 'white',
            bgcolor: 'rgba(0, 0, 0, 0.5)',
            transition: 'all 0.2s',
            zIndex: theme.zIndex.modal + 1,
            '&:hover': {
              bgcolor: 'rgba(0, 0, 0, 0.8)',
              transform: 'scale(1.1)',
            },
          }}
        >
          <CloseIcon />
        </IconButton>

        <SecureImage
          src={imageUrl || ''}
          path={imagePath || undefined}
          alt={altText}
          onClick={(e) => e.stopPropagation()}
          sx={{
            display: 'block',
            maxWidth: '100vw',
            maxHeight: '90vh',
            width: 'auto',
            height: 'auto',
            objectFit: 'contain',
            borderRadius: 1,
            boxShadow: theme.shadows[10],
          }}
        />
      </Box>
    </Dialog>
  );
}
